// extracted by mini-css-extract-plugin
export default {"button":"LoginBoxStyles__button___ZHWQA","dateColumn":"LoginBoxStyles__dateColumn___FmuJw","dateRow":"LoginBoxStyles__dateRow___JTBnc"};